import {
  FlexBox,
  NumberInput,
  ThumbnailLayout,
} from '@airship-platform/jam-web/components';
import { BoxIcon } from '@airship-platform/jam-web/icons';
import Typography from '@mui/material/Typography';
import { AppointmentProposalOptionProduct } from '../../../data-access/appointmentProposalOptionProducts';
import SubItemRowPrice from './SubItemRowPrice';

type ProductUpdatePayload = Partial<
  Pick<
    AppointmentProposalOptionProduct,
    'quantity' | 'price' | 'defaultPriceType'
  >
>;

interface SubItemRowProps {
  product: AppointmentProposalOptionProduct;
  isReadOnly: boolean;
  onProductUpdate: (update: ProductUpdatePayload) => void;
  onDelete: (product: AppointmentProposalOptionProduct) => void;
}

const SubItemRow: React.FC<SubItemRowProps> = ({
  product,
  isReadOnly,
  onProductUpdate,
  onDelete,
}) => {
  const imageUrl = product.images
    .filter((image) => image.type === 'Image')
    .map((image) => image.url)
    .find(Boolean);

  return (
    <FlexBox
      alignItems={'center'}
      justifyContent={'space-between'}
      gap={2}
      py={1}
    >
      <ThumbnailLayout
        imageUrl={imageUrl}
        imageAlt={product.name}
        fallback={<BoxIcon />}
        imageProps={{ width: '3rem', height: '3rem', minWidth: '3rem' }}
        sx={{ width: '100%', flex: 1, minWidth: 0 }}
      >
        <FlexBox flexDirection="column" gap={0.5} flex={1} width={'100%'}>
          <Typography variant="body1">{product.name}</Typography>
          <SubItemRowPrice
            product={product}
            isReadOnly={isReadOnly}
            onPriceChange={(values) => {
              onProductUpdate({
                price: values.price,
                defaultPriceType: values.defaultPriceType,
              });
            }}
          />
        </FlexBox>
      </ThumbnailLayout>
      <NumberInput
        initialValue={product.quantity || 1}
        disabled={isReadOnly}
        onChange={(quantity) => onProductUpdate({ quantity })}
        onDelete={() => onDelete(product)}
        width={'auto'}
      />
    </FlexBox>
  );
};

export default SubItemRow;
